import { MultipleUnitPaging } from "./MultipleUnitPaging";

export const MultipleUnitPagingContainer = MultipleUnitPaging;
